import { z } from 'zod';

const prodEnvSchema = z.object({
  API_URL: z.string().nonempty().url(),
  TAVOLA_BASE_URL: z.string().nonempty().url(),
  FLUX_API_URL: z.string().nonempty().url(),
  SENTRY_DSN: z.string().nonempty().url(),
  SENTRY_ENVIRONMENT: z.string().nonempty(),
  APP_VERSION: z.string().nonempty(),
  APP_MODE: z.union([z.literal('development'), z.literal('staging'), z.literal('sandbox'), z.literal('production')]),
  GTM_ID: z.string().nonempty(),
  LACUNA_WEB_PKI_LICENSE: z.string().nonempty(),
  MOCK_API: z.string().toLowerCase().transform((x) => x === 'true').pipe(z.boolean())
    .optional(),
  LIVENESS_URL_BASE: z.string().optional().nullable(),
  LIVENESS_CONFIRM_END_POINT: z.string().optional().nullable(),
});

const devEnvSchema = z.object({
  API_URL: z.string().nonempty().url(),
  TAVOLA_BASE_URL: z.string().nonempty().url(),
  FLUX_API_URL: z.string().nonempty().url(),
  SENTRY_DSN: z.string().optional(),
  SENTRY_ENVIRONMENT: z.string().optional(),
  APP_VERSION: z.string().optional(),
  APP_MODE: z.union([z.literal('development'), z.literal('staging'), z.literal('sandbox'), z.literal('production')]),
  GTM_ID: z.string().optional().nullable(),
  LACUNA_WEB_PKI_LICENSE: z.string().optional(),
  MOCK_API: z.string().toLowerCase().transform((x) => x === 'true').pipe(z.boolean())
    .optional(),
  LIVENESS_URL_BASE: z.string().optional().nullable(),
  LIVENESS_CONFIRM_END_POINT: z.string().optional().nullable(),
});

const envSchema = import.meta.env.VITE_APP_MODE !== 'development' ? prodEnvSchema : devEnvSchema;

const environment = {
  API_URL: import.meta.env.VITE_API_URL,
  FLUX_API_URL: import.meta.env.VITE_FLUX_API_URL,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.VITE_APP_MODE,
  APP_VERSION: import.meta.env.VITE_APP_VERSION,
  APP_MODE: import.meta.env.VITE_APP_MODE,
  GTM_ID: import.meta.env.VITE_GTM_ID,
  TAVOLA_BASE_URL: import.meta.env.VITE_API_URL?.replace(/\/$/, ''),
  LACUNA_WEB_PKI_LICENSE: import.meta.env.VITE_LACUNA_WEB_PKI_LICENSE,
  MOCK_API: import.meta.env.VITE_MOCK_API,
  LIVENESS_URL_BASE: import.meta.env.VITE_LIVENESS_URL_BASE,
  LIVENESS_CONFIRM_END_POINT: import.meta.env.VITE_LIVENESS_CONFIRM_END_POINT,
};

export const env = Object.freeze(envSchema.parse(environment));
